import axios from 'axios';
import type { EnhancedAppointment, JsonObject } from '@bb/domain/dist/types';
import type { User } from '@bb/users';
import type { ListingDoc, OrgDoc } from '@bb/domain/dist/schemas';

const getAppointmentByIdForCoop = async (appointmentId: string) => {
  const { data } = await axios.get<
    JsonObject<{
      appointment: EnhancedAppointment;
      listing: Omit<ListingDoc, 'reps' | 'org'> & {
        reps: User[];
        org: OrgDoc;
      };
    }>
  >(`/user/coop/appointment/${appointmentId}`);

  return data;
};

export default getAppointmentByIdForCoop;
